import { render, staticRenderFns } from "./prove.vue?vue&type=template&id=bc31b9c8&scoped=true"
import script from "../../assets/ts/prove-view/prove.ts?vue&type=script&lang=ts&external"
export * from "../../assets/ts/prove-view/prove.ts?vue&type=script&lang=ts&external"
import style0 from "./prove.vue?vue&type=style&index=0&id=bc31b9c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc31b9c8",
  null
  
)

export default component.exports